import apiClient from '../../utils/axiosConfig';
import type { Policy, PolicyCreateRequest, PoliciesListResponse } from './types';

const BASE = '/api/policies/';

export const policiesService = {
  async getPolicies(): Promise<PoliciesListResponse> {
    const response = await apiClient.get<PoliciesListResponse>(BASE);
    return response.data;
  },

  async createPolicy(data: PolicyCreateRequest): Promise<Policy> {
    const response = await apiClient.post<Policy>(BASE, data);
    return response.data;
  },

  async getPolicy(id: number): Promise<Policy> {
    const response = await apiClient.get<Policy>(`${BASE}${id}/`);
    return response.data;
  },

  async updatePolicy(id: number, data: Partial<PolicyCreateRequest>): Promise<Policy> {
    const response = await apiClient.patch<Policy>(`${BASE}${id}/`, data);
    return response.data;
  },

  async deletePolicy(id: number): Promise<void> {
    await apiClient.delete(`${BASE}${id}/`);
  },

  async downloadPDF(id: number): Promise<Blob> {
    const response = await apiClient.get(`${BASE}${id}/download-pdf/`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
